export default __webpack_public_path__ + "static/logo-square-wob-7c233affb807820a2bb911042f8fcb22.png";